import { createContext, useContext, useEffect, useState } from "react";

const CartCtx = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("cart") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => localStorage.setItem("cart", JSON.stringify(items)), [items]);

  const has = (id) => items.some((i) => i.id === id);
  const toggle = (item) =>
    setItems((cur) => (cur.some((i) => i.id === item.id) ? cur.filter((i) => i.id !== item.id) : [...cur, item]));
  const addMany = (list) =>
    setItems((cur) => [...cur, ...list.filter((x) => !cur.some((i) => i.id === x.id))]);
  const remove = (id) => setItems((cur) => cur.filter((i) => i.id !== id));
  const clear = () => setItems([]);
  const subtotal = items.reduce((s, i) => s + Number(i.price || 0), 0);
  const groups = Object.values(
    items.reduce((acc, i) => {
      const g = (acc[i.event_id] ||= { event_id: i.event_id, event_name: i.event_name, count: 0, sum: 0, pkg: Number(i.package_price || 0) });
      g.count += 1;
      g.sum += Number(i.price || 0);
      return acc;
    }, {})
  ).map((g) => ({ ...g, total: g.pkg && g.sum > g.pkg ? g.pkg : g.sum, packaged: !!(g.pkg && g.sum > g.pkg) }));
  const total = groups.reduce((s, g) => s + g.total, 0);

  return (
    <CartCtx.Provider value={{ items, has, toggle, addMany, remove, clear, total, subtotal, groups }}>{children}</CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
